<template>
  <div class="flex flex-row gap-3 items-center overlay text-center">
    <div class="inline-block font-normal">Was this response helpful?</div>
    <TMSecondaryButton
      v-if="showThumbsUp"
      icon="thumbsUp"
      :disabled="disabled"
      @click="() => submitCoarseFeedback(true)"
    />
    <TMSecondaryButton
      v-if="showThumbsDown"
      icon="thumbsDown"
      :disabled="disabled"
      @click="() => submitCoarseFeedback(false)"
    />
  </div>
</template>

<script lang="ts">
import TMSecondaryButton from '@thyme/nashville/src/components/button/TMSecondaryButton.vue'
import { defineComponent } from 'vue'
import { setup } from './controller'
import { COARSE_FEEDBACK_PROPS } from './types'

export default defineComponent({
  components: { TMSecondaryButton },
  props: COARSE_FEEDBACK_PROPS,
  setup,
})
</script>
